export default "__VITE_ASSET__ClHs9X4U__"